<template>
  <div class="pop-dim">
    <div class="pop-wrap">
      <h2>UT링크</h2>
      <p>
        테스트 진행을 위해 On 상태의 링크를 공유해주세요.<br>
        Off 상태의 UT에는 접근이 불가합니다
      </p>
      <h3>상태 : {{getOnOff}}</h3>
      <div class="url-toast-wrap">
        <div class="url-box">
          {{ bridgeUrl }}
        </div>
        <div class="toast-pop" v-if="isToastPop">
          클립보드에 복사되었습니다 <img src="@/assets/images/icon-layer-toast.svg" alt="">
        </div>
      </div>
      <button-item :btnText="'복사'" :btnClass="'layerpop-btn'" @click="onCopyURL"/>
      <div class="pop-close" @click="onClose"></div>
    </div>
  </div>
</template>

<script>
import ButtonItem from '@/components/ui/button'
import { BRIDGE_BASE_URL, TOAST_TIMER } from '@/libs/constants'

export default {
  name: 'LinkLayerPop',
  components: {
    ButtonItem
  },
  props: [
    'data'
  ],
  data () {
    return {
      isToastPop: false,
      bridge_base_url: BRIDGE_BASE_URL
    }
  },
  computed: {
    bridgeUrl () {
      return this.bridge_base_url + this.data.utid
    },
    getOnOff () {
      if (this.data.state === 'run') {
        return 'ON'
      } else {
        return 'OFF'
      }
    }
  },
  created () {

  },
  destroyed () {
  },
  methods: {
    onClose () {
      this.$close(false)
    },
    onCopyURL () {
      const el = document.createElement('textarea')
      el.value = this.bridgeUrl
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.isToastPop = true
      setTimeout(function () {
        this.isToastPop = false
      }.bind(this), TOAST_TIMER)
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 510px;
  height: 350px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  text-align: center;
  box-sizing: border-box;
  padding: 0 30px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    color: #444;
    margin: 50px 0 12px;
  }

  p {
    font-size: 14px;
    line-height: 1.5;
    color: #2f2f2f;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #ec0047;
    margin: 23px 0 30px;
  }

  .url-toast-wrap {
    position: relative;

    .url-box {
      width: 100%;
      height: 40px;
      border-radius: 6px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;
      font-size: 14px;
      line-height: 40px;
      color: #2f2f2f;
      text-align: left;
      padding: 0 10px;
      box-sizing: border-box;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-bottom: 45px;
    }

    .toast-pop {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 200px;
      height: 32px;
      border-radius: 6px;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
      background: #000;
      font-size: 13px;
      color: #57ab00;
      box-sizing: border-box;
      line-height: 32px;
      padding-left: 10px;

      img {
        display: inline-block;
        vertical-align: middle;
        line-height: 32px;
        margin: -3px 0 0 7px;
      }
    }
  }

  .pop-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 10px;
    background: url('../../assets/images/icon-layer-close.svg') no-repeat center;
    cursor: pointer;
  }
}
</style>
